export class Pair<TL, TR> {
    valueA: TL
    valueB: TR

    constructor(valueA: TL, valueB: TR) {
        this.valueA = valueA
        this.valueB = valueB
    }
}

export const pair = <TL, TR>(left: TL, right: TR) => new Pair(left, right)
